// extracted by mini-css-extract-plugin
export default {"Spinner":"qNqvnOcFxSYJO8W6wgBL","spin":"KPleDFL6YYGIfsyh6cVM"};